<script lang="ts">
    import LoginForm from './login-form.svelte'

    function loginSuccess() {
        location.href = '/'
    }
</script>

<main class="root">
    <div class="in">
        <!-- lado da arte: some no celular, onde a tela inteira é o formulário -->
        <div class="box pub">
            <div class="-ilustration">
                <img src="/img/sign.png" alt="" />
            </div>
            <span class="e-1"><b>Bem vindo</b> ao Zandu</span>
            <span class="e-2">Sua agenda, seu caixa e seus clientes no mesmo lugar.</span>
        </div>
        <div class="box form">
            <div class="form-in">
                <div class="-logo">
                    <img src="/img/logo_white.png" alt="Zandu" />
                </div>
                <LoginForm on:success={loginSuccess} />
            </div>
        </div>
    </div>
</main>

<style>
    .root {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        width: 100vw;
        background: url('/img/bg_login.png') #2f2f2f center center no-repeat;
        background-size: auto;
    }

    .root .in {
        /* cartão de vidro. O fundo é uma ilustração de cores fortes: o preto precisa ser fechado o
           bastante para o texto branco não disputar com o vermelho do balão que passa por trás. */
        background: rgba(0, 0, 0, 0.72);
        border-radius: 20px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.45);
        backdrop-filter: blur(18px);
        -webkit-backdrop-filter: blur(18px);
        border: 1px solid rgba(255, 255, 255, 0.08);
        flex: 0 1 940px;
        max-height: 100vh;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        margin: 8px;
    }

    .in .box {
        min-height: 420px;
    }

    .in .pub {
        background-color: #ffffff;
        padding: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        flex: 0 0 42%;
    }
    .-ilustration {
        overflow: hidden;
        margin-bottom: 20px;
    }
    .-ilustration img {
        max-height: 230px;
        max-width: 80vw;
    }
    .e-1 {
        font-weight: 300;
        font-size: 24px;
        color: #1f2328;
    }
    .e-1 b {
        font-weight: 400;
        background: #ffc46b;
        padding: 0px 6px;
        border-radius: 6px;
    }
    .e-2 {
        margin-top: 10px;
        font-size: 14px;
        line-height: 1.4;
        max-width: 280px;
        color: #5b6470;
    }

    .in .form {
        padding: 32px 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
    }
    .in .form-in {
        flex-grow: 1;
    }
    .-logo {
        text-align: center;
        margin-bottom: 28px;
    }
    .-logo img {
        max-width: 150px;
    }

    @media (max-width: 900px) {
        .root {
            /* no celular o formulário ocupa a tela toda: o vidro vira a própria página */
            align-items: stretch;
        }
        .root .in {
            /* ocupando a tela toda, o vidro deixaria de ser efeito e viraria só um borrão colorido
               atrás do formulário — aqui ele é um fundo sólido */
            flex: 1 1 auto;
            margin: 0px;
            border: 0px;
            border-radius: 0px;
            max-height: none;
            background: #232323;
            backdrop-filter: none;
            -webkit-backdrop-filter: none;
        }
        .in .pub {
            display: none;
        }
        .in .form {
            padding: 24px 20px;
        }
    }
</style>
